<ng-container *ngIf="permissionsMap[PermissionKeys.CUSTOMPACKAGE_READ]; else permissionNotAvailable">
<div class="pt-24 pl-72 pr-72">
  <app-breadcrumb class="mt-16" [items]="breadcrumbItems">
  </app-breadcrumb>
</div>
<div class="ml-72 mr-72 mb-24 custom-container">
  <div class="flex flex-row items-center justify-between header-section">
    <div class="flex items-center">
      <img class=" ml-34 icon -mr-4 mt-20" src="/assets/icons/package.svg">
      <div class="mat-subtitle-2 mb-0 fs-24 fw-600 pl-20 pt-20">{{'CUSTOM_IMAGES.CUSTOM_IMAGES' | transloco}}<span *ngIf="!showSpinner && showTable">
        ({{searchTerm?.length > 0 && searchedResult ? searchedResult.length : imageData?.length}})
      </span></div>
      <app-search-filter *ngIf="customImageData?.length > 0" class="mt-20 ml-20" placeholder="SEARCH.SEARCH"
        (changed)="search($event)"></app-search-filter>
      <div *ngIf="customImageData?.length > 0" class="vertical-dash ml-12 mr-12 mt-20"></div>
      <div *ngIf="customImageData?.length > 0" class="mt-20">
        <button class="flex justify-center items-center custom-filter pl-6 pr-16 h-34" (click)="filterColumns()">
          <mat-icon class="mr-4" svgIcon="filter_alt"></mat-icon>
          <span class="mat-body-1 fw-500">{{'SOLUTIONS.FILTERS' | transloco }}</span>
        </button>
      </div>
    </div>
    <div class="flex items-center">
      <mat-select class="fw-500 form-select fs-16 cust-img mt-16 mr-20"
        placeholder="{{'CUSTOM_IMAGES.CHOOSE_SOLUTION' | transloco}}" [(value)]="selectedSolutionId" (selectionChange)="onUserSelectionChange($event.value)"
        panelClass="cust-img" (closed)="resetDropdown()">
        <div class="flex relative m-8"><input [(ngModel)]="dropdownSearchValue"
            (ngModelChange)="searchChanged(dropdownSearchValue)" class="fw-400 h-34 search-text pl-12"
            placeholder="{{'SEARCH.SEARCH' | transloco}}" type="text">
          <span (click)="searchChanged(dropdownSearchValue)" class="cursor-pointer absolute"><mat-icon
              class="icon-md icon-color search-icon mt-4" svgIcon="search"></mat-icon></span>
        </div>
        <mat-option *ngIf="!isSolutionsLoaded">
          <div class="flex items-center justify-center spinner-width mb-16 mt-16">
            <mat-spinner class="mr-8" diameter="20"
              color="primary"
              mode="indeterminate">
            </mat-spinner>
          </div>
        </mat-option>
        <mat-option *ngIf="isSolutionsLoaded && (!solutions || solutions?.length === 0)">
          <div class="ml-16 mr-16 mt-8 mb-8">
            {{'CUSTOM_IMAGES.NO_SOL_FOUND' | transloco}}</div>
        </mat-option>
        <ng-container *ngFor="let version of solutions; let i = index">
          <mat-option [value]="version.id">{{version.value}}</mat-option>
          <mat-divider *ngIf="i < solutions.length - 1" class="neutral-2 mb-4"></mat-divider>
        </ng-container>
      </mat-select>
      <button type="submit" class="flex accent h-32 mt-16 mr-20" *ngIf="permissionsMap[PermissionKeys.CUSTOMPACKAGE_CREATE]" (click)="createCustomImage()">
        <mat-icon svgIcon="add" class="mr-6 mt-6 icon-sm"></mat-icon>{{'CUSTOM_IMAGES.CREATE_CUSTOM_IMAGE' | transloco}}</button>
    </div>
  </div>
  <div *ngIf="customImageData?.length > 0" class="flex flex-row items-center mt-8 ml-38">
         <div class="mr-4 pt-8 pb-4 filtered-items flex items-center fs-16 fw-500" *ngIf="selectedUser?.length > 0">
               <span *ngFor="let user of selectedUser" class="flex justify-center items-center btn-rounded mat-body-1 fw-500 pl-12 pr-12 pt-4 pb-4 mr-16">
                  {{getUserLabel(user)}}
                  <mat-icon svgIcon="close" class="ml-6 icon-sm" (click)="cancelUserFilter(user)"></mat-icon>
               </span>
         </div>
         <div class="mr-4 pt-8 pb-4 filtered-items flex items-center fs-16 fw-500" *ngIf="filterStartDate && filterEndDate">
            <span class="flex justify-center items-center btn-rounded mat-body-1 fw-500 pl-12 pr-12 pt-4 pb-4 mr-16">
               <span class="date-label">{{'TENANT_DETAILS.CREATED_DATE' | transloco}} :&nbsp; </span>{{ datePipe.transform(filterStartDate, 'dd MMM yyyy') }} - {{ datePipe.transform(filterEndDate, 'dd MMM yyyy') }}
               <span class="ml-8">
               <mat-icon svgIcon="close" class="cursor-pointer icon-sm" (click)="cancelCustomImageDateFilter()"></mat-icon>
               </span>
            </span>
         </div>
         <div class="flex flex-row items-center">
            <span *ngIf="selectedUser?.length > 0 || (filterStartDate && filterEndDate)" class="flex justify-center items-center mat-subtitle-2 mb-0 fw-500 cursor-pointer warn-solid-fg" (click)="resetCustomImageFilter()">
               {{ 'BUTTONS.CLEAR_ALL' | transloco }}
            </span>
         </div>
      </div>
  <div *ngIf="(showTable && customImageData?.length > 0) || showSpinner; else notFound" class="p-20 pt-24">
    <app-table [initialDataSource]="imageData" [selectedSolutionValue]="selectedSolutionValue" [selectedSolutionId]="selectedSolutionId" [searchTerm]="searchTerm" [displayColumns]="displayColumns"
      [dataLoading]="showSpinner" [showSkeletonLoader]="true" page="customImage" [dataSourceLength]="true"
      [initialCreate]="customImageData?.length === 0" pageName="customImages"
      (searchedResults)="searchedItems($event)" (custImageTable)="getCustomImages()"></app-table>
  </div>
  <ng-template #notFound>
    <div *ngIf="(showTable && apiNotFound) || (!showTable && !showSpinner && this.allExternalPackages?.length === 0)" class="no-data flex items-center justify-center pt-8 pb-8 mt-80 flex-col empty-data">
      <img src="/assets/images/service_not_found.png" alt="No data found" class="w-106" />
      <div class="mt-6">{{'INSTANCE_LIST.NO_DATA_FOUND' | transloco }}</div>
    </div>
  </ng-template>
  <div *ngIf="!showTable && !showSpinner && !allExternalPackages" class="p-20 pt-100 justify-items-center">
    <div>{{'CUSTOM_IMAGES.VIEW_CUST_IMAGE_MSG' | transloco}}</div>
  </div>
</div>
</ng-container>
<ng-template #permissionNotAvailable>
  <div class="flex flex-col items-center no-permission justify-center ml-60 mr-60 pb-100 pt-100 mt-32 fs-16">
    <img src="/assets/images/no_access_schedule.png"> 
    <div class="mt-10 feature-not-avaliable">{{'CUSTOM_IMAGES.NO_ACCESS' | transloco}}</div>
  </div>
</ng-template>